import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { Tweens } from "../Components/Effects/Tweens";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";

@engineComponent(ComponentTypes.DisplayObject)
export class ImageTextCounterElementExtended extends ImageTextCounterElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    public imageText: ImageTextElement;

    //******************************************************************************************************************
    //  CREATE, UPDATE
    //******************************************************************************************************************

    public createByNode(node: Element) {
        super.createByNode(node);

        if (this.imageText == null) {
            if (this.font != null) {
                this.imageText = new ImageTextElement();
                this.imageText.visible = false;
                this.imageText.font = this.font + "Blend";
                this.imageText.text = this.text;
                this.imageText.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font + "Blend" });
                this.imageText.addChild(this.imageText.bitmapText);

                this.addChild(this.imageText);
            }
        }
    }

    public updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.hasAttribute("Glow")) {
            this.glowAsHighWin();
        }
    }

    //******************************************************************************************************************
    //  REALIGN
    //******************************************************************************************************************

    public realign(): void {
        super.realign();

        this.imageText.position.x = this.bitmapText.position.x;
        this.imageText.position.y = this.bitmapText.position.y;
    }

    //******************************************************************************************************************
    //  START
    //******************************************************************************************************************

    protected onCountTo(): void {
        super.onCountTo();

        this.imageText.bitmapText.text = this.bitmapText.text;
    }

    //******************************************************************************************************************
    //  GLOW
    //******************************************************************************************************************

    public glowAsWin(): void {
        this.imageText.visible = true;

        Tweens.removeTweens(this.imageText, "all");
        Tweens.alphaTween(this.imageText, {
            alphas: [0, 1],
            tweenDuration: 5,
            tweenDelay: 20,
            callbackFunction: (): void => {
                Tweens.removeTweens(this.imageText, "all");
                Tweens.alphaTween(this.imageText, {
                    alphas: [1, 1, 0],
                    tweenDuration: 30,
                    callbackFunction: (): void => {
                        this.imageText.visible = false;
                    },
                });
            },
        });
    }

    public glowAsHighWin(): void {
        this.imageText.visible = true;

        Tweens.removeTweens(this.imageText, "all");
        Tweens.alphaTween(this.imageText, {
            alphas: [0, 1],
            tweenDuration: 5,
            callbackFunction: (): void => {
                Tweens.removeTweens(this.imageText, "all");
                Tweens.alphaTween(this.imageText, {
                    alphas: [1, 1, 0],
                    tweenDuration: 60,
                    callbackFunction: (): void => {
                        this.imageText.visible = false;
                    },
                });
            },
        });
    }

    //******************************************************************************************************************
    //  CLONE
    //******************************************************************************************************************

    public clone(): ImageTextCounterElement {
        let element: ImageTextCounterElementExtended = new ImageTextCounterElementExtended();
        element.visible = this.visible;
        element.alpha = this.alpha;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;

        element.font = this.font;
        element.text = this.text;
        element.textAlign = this.textAlign;
        element.textBaseline = this.textBaseline;

        element.from = this.from;
        element.to = this.to;
        element.duration = this.duration;
        element.round = this.round;

        element.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font });
        element.addChild(element.bitmapText);

        element.imageText = this.imageText.clone();
        element.imageText.visible = false;
        element.addChild(element.imageText);

        element.realign();
        element.markAsCloned();

        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ImageTextCounterElementExtended.ts
 **/